import { callAction } from './client';
import { MenuResponse } from './types';

export function getMenu(categoryName: string): Promise<MenuResponse> {
  return callAction<MenuResponse>('get_menu', { category_name: categoryName });
}
